import { Doughnut } from "react-chartjs-2";
import { Chart, ArcElement } from "chart.js";

Chart.register(ArcElement);



const DoughnutChart = ({currentValue, maxValue,unitMeasurement}) => {
const ratio = Number(currentValue) / ( Number(currentValue) + Number (maxValue) )
let color;

switch (true) {
  case ratio < 0.5:
    color = "#008000";
    break;
  case ratio <= 0.75:
    color = '#FFFF00'; //yellow
    break;
  case ratio > 0.75:
    color = '#FF0000'; //red
    break;
  default:
    color = '#ffff'; // Default color if none of the conditions are met
}


  const data = {
    datasets: [
      {
        data: [currentValue, maxValue],
        backgroundColor: [
          color,
          "#ffff"
          
        ],
        display: true,
        borderColor: "#D1D6DC"
      }
    ]
  };


  return (
    <>
      <Doughnut
      className="monitorDoughnut"
        data={data}
        options={{
          plugins: {
            legend: {
              display: false
            },
            tooltip: {
              enabled: false
            }
          },
          rotation: -90,
          circumference: 180,
          cutout: "60%",
          maintainAspectRatio: true,
          responsive: true
        }}
      />
    
    </>
  );
};

export default DoughnutChart;
